// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"5ddcf7c3","213":"109ba313","301":"7918e92c","451":"b400b422","455":"9798b7a5","530":"293bf3f6","711":"aed2ffe7","745":"7e75926f"}[chunkId] + ".chunk.js";
};